import { useEffect } from "react";

const SITE_URL = "https://www.parsngroup.com";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

const absolutize = (src) => (src && src.startsWith("/") ? `${SITE_URL}${src}` : src);

const setMeta = (selector, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [key, val] = selector.replace(/meta\[|\]/g, "").split("=");
    el.setAttribute(key, val.replace(/"/g, ""));
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

export const SEO = ({ title, description, image, path = "/" }) => {
  useEffect(() => {
    if (title) {
      document.title = title;
      setMeta('meta[property="og:title"]', "content", title);
      setMeta('meta[name="twitter:title"]', "content", title);
    }
    if (description) {
      setMeta('meta[name="description"]', "content", description);
      setMeta('meta[property="og:description"]', "content", description);
      setMeta('meta[name="twitter:description"]', "content", description);
    }
    const img = absolutize(image) || DEFAULT_IMAGE;
    setMeta('meta[property="og:image"]', "content", img);
    setMeta('meta[name="twitter:image"]', "content", img);
    setMeta('meta[property="og:url"]', "content", `${SITE_URL}${path}`);
  }, [title, description, image, path]);
  return null;
};
